import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { clubInterestService } from '../../../services/emailAlertService';
import { playerProfileService } from '../../../services/playerMasterService';
import { useAuth } from '../../../contexts/AuthContext';

const QuickActions = ({ userType }) => {
  const { hasAnyRole } = useAuth();
  const isPlayerOrCoach = hasAnyRole(['player', 'coach']);
  const [recentInterest, setRecentInterest] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isPlayerOrCoach) {
      fetchRecentInterest();
    } else {
      setLoading(false);
    }
  }, [isPlayerOrCoach]);

  const fetchRecentInterest = async () => {
    try {
      const playerResponse = await playerProfileService?.getByCurrentUser();
      const playerId = playerResponse?.data?.id;

      if (playerId) {
        const interestResponse = await clubInterestService?.getByPlayer(playerId);
        setRecentInterest(interestResponse?.data?.slice(0, 3) || []);
      }
    } catch (error) {
      console.error('Error fetching recent interest:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  const actions = [
    {
      id: 'search',
      label: 'Search Players',
      description: 'Find and connect with other players',
      icon: 'Search',
      color: 'bg-primary/10 text-primary',
      onClick: () => console.log('Search Players'),
    },
    {
      id: 'report',
      label: 'Generate Report',
      description: 'Create a report on player performance',
      icon: 'FileText',
      color: 'bg-accent/10 text-accent',
      onClick: () => console.log('Generate Report'),
    },
    {
      id: 'analysis',
      label: 'Market Analysis',
      description: 'Analyze player market trends',
      icon: 'TrendingUp',
      color: 'bg-error/10 text-error',
      onClick: () => console.log('Market Analysis'),
    },
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-6 shadow-card">
      <h2 className="text-xl font-bold text-foreground mb-6 font-headline flex items-center gap-2">
        <Icon name="Zap" size={24} className="text-primary" />
        Quick Actions
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {actions?.map((action) => (
          <button
            key={action?.id}
            onClick={action?.onClick}
            className="flex items-start gap-4 p-4 rounded-lg border border-border hover:bg-muted hover:border-primary transition-all duration-300 text-left group"
          >
            <div className={`w-12 h-12 rounded-lg ${action?.color} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
              <Icon name={action?.icon} size={24} />
            </div>
            <div className="flex-1">
              <p className="text-base font-semibold text-foreground mb-1">{action?.label}</p>
              <p className="text-sm text-muted-foreground">{action?.description}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;